import React, { useState, useEffect, useCallback } from 'react';
import classNames from 'classnames';
import ScrollMenu from 'react-horizontal-scrolling-menu';
import {
  disableBodyScroll,
  enableBodyScroll,
  clearAllBodyScrollLocks,
} from 'body-scroll-lock';
import './styles.css';

const HorizontalScroll = ({ data, lockScroll, className, arrows }) => {
  const [preventVerticalScroll, setPreventVerticalScroll] = useState();
  const [firstScrolled, setFirstScrolled] = useState();

  const enableVerticalScroll = useCallback(() => {
    if (className && lockScroll) {
      enableBodyScroll(document.querySelector(`.${className}`));
    }
  }, [className, lockScroll]);

  const disableVerticalScroll = useCallback(() => {
    if (className && lockScroll) {
      disableBodyScroll(document.querySelector(`.${className}`));
    }
  }, [className, lockScroll]);

  useEffect(() => {
    enableVerticalScroll();
    if (preventVerticalScroll) {
      disableVerticalScroll();
    }
    return () => {};
  }, [preventVerticalScroll]);

  function onFirstTouch() {
    setPreventVerticalScroll(true);
  }

  useEffect(() => {
    if (className && lockScroll) {
      document
        .querySelector(`.${className}`)
        .addEventListener('touchstart', onFirstTouch);
      return () => window.removeEventListener('touchstart', onFirstTouch);
    }
    return () => {
      clearAllBodyScrollLocks();
    };
  }, [className, lockScroll]);

  return (
    <div
      className={classNames('HorizontalScroll__root', {
        [className]: className,
      })}
    >
      <ScrollMenu
        data={data}
        wheel={false}
        alignCenter={false}
        hideSingleArrow={arrows}
        hideArrows={!arrows}
        scrollBy={1}
        onFirstItemVisible={() => {
          setTimeout(() => {
            setPreventVerticalScroll(false);
            enableVerticalScroll();
          }, 300);
        }}
        onLastItemVisible={() => {
          setTimeout(() => {
            setPreventVerticalScroll(false);
            enableVerticalScroll();
          }, 300);
        }}
        onUpdate={() => {
          setFirstScrolled(true);
          setPreventVerticalScroll(false);
          enableVerticalScroll();
        }}
        arrowLeft={
          arrows && firstScrolled ? (
            <span className="HorizontalScroll__arrow">
              <i className="icon-generalarrowwlarge" />
            </span>
          ) : null
        }
        arrowRight={
          arrows ? (
            <span className="HorizontalScroll__arrow">
              <i className="icon-generalarrowelarge" />
            </span>
          ) : null
        }
      />
    </div>
  );
};

export default HorizontalScroll;
